import React from 'react';
import CostTable from "../CostTable/CostTable";
import PromoBanner from "../PromoBanner/PromoBanner";
import EducationLoanBannerPhoto from "../../images/education_loan_banner_photo.jpg";
import PayEducation from "../PayEducation/PayEducation";
import {faPercentage, faIdCard, faHandHoldingUsd, faCalendarAlt} from '@fortawesome/free-solid-svg-icons';
import FirstCourse from "../../pdf/dogovor_stoimost_1_course.pdf";
import Dogovor_poryadok from "../../pdf/poryadok_platn_uslug.pdf";
import Dogovor_SPO from "../../pdf/dogovor_platn_obraz_uslug_SPO_05_06_2024.pdf";
import Dogovor_OTHER from "../../pdf/dogovor_platn_obraz_uslug_05_06_2024.pdf";
import Dogovor_SPO_foreigners from "../../pdf/dogovor_platn_obraz_uslug_SPO_18_06_2025.pdf";
import Dogovor_OTHER_foreigners from "../../pdf/dogovor_platn_obraz_uslug_VO_18_06_2025.pdf";
import College_graduates_special_offer from "../../pdf/college_graduates_special_offer.pdf"

const App8 = ({selectedLevelsId = [1, 2, 3, 4, 7]}) => {

    let pdfCards = [
        {
            file: FirstCourse,
            title: "Стоимость обучения за 1 курс"
        },
        {
            file: Dogovor_poryadok,
            title: "Порядок оказания платных образовательных услуг"
        },
        {
            file: selectedLevelsId.length === 1 && selectedLevelsId[0] === 4 ? Dogovor_SPO : Dogovor_OTHER,
            title: "Договор на оказание платных образовательных услуг"
        },
        {
            file: selectedLevelsId.length === 1 && selectedLevelsId[0] === 4 ? Dogovor_SPO_foreigners : Dogovor_OTHER_foreigners,
            title: "Договор на оказание платных образовательных услуг для иностранных граждан"
        }
    ];

    pdfCards = selectedLevelsId.length === 2 &&
    selectedLevelsId.includes(1) &&
    selectedLevelsId.includes(2)
        ? [
            ...pdfCards,
            {
                file: College_graduates_special_offer,
                title: "Стоимость обучения за 1 курс для выпускников колледжа ГГУ"
            }
        ]
        : pdfCards;

    return (
        <div className="DocumentLinksPage__content-container">
            <CostTable programIds={selectedLevelsId}/>
            <p>
                У нас <a href="https://www.art-gzhel.ru/sveden/document/doc/platn_uslugi/pol_snizh_stoim_24_02_2025.pdf"
                         target="_blank" rel="noopener noreferrer">
                предусмотрены скидки
            </a> за обучение!
            </p>
            <a
                href="https://www.sberbank.com/ru/person/credits/money/credit_na_obrazovanie"
                target="_blank"
                rel="noopener noreferrer"
                style={{textDecoration: "none", color: "inherit"}}
            >
                <PromoBanner
                    title="Образовательный кредит с государственной поддержкой"
                    description="Получайте высшее или среднее профессиональное образование, а государство погасит часть кредита за вас."
                    listItems={[
                        {text: "Льготная ставка на весь срок кредита", icon: faPercentage},
                        {text: "Оформление с 14 лет без справки о доходах", icon: faIdCard},
                        {text: "Государство погашает часть кредита", icon: faHandHoldingUsd},
                        {text: "Длительный срок погашения", icon: faCalendarAlt}
                    ]}
                    imageSrc={EducationLoanBannerPhoto}
                    imageAlt="Студенты"
                />
            </a>

            <a href="https://www.art-gzhel.ru/pyform/" className="link_button">Перейти к оплате</a>

            <PayEducation pdfCards={pdfCards}/>
        </div>
    );
}

export default App8;
